module.exports = function() {
  return new Worker(__webpack_public_path__ + "2422597678d6dc0cc453.worker.js");
};